import SkillsCard from "./SkillsCard";

const Skills = () => {
  const images = [
    "../../svg/html5.svg",
    "../../svg/css3.svg",
    "../../svg/javascript.svg",
    "../../svg/bootstrap.svg",
    "../../svg/java-vertical.svg",
    "../../svg/react.svg",
    "../../svg/nodejs.svg",
    "../../svg/mongodb.svg",
    "../../svg/postman.svg",
    "../../svg/mysql.svg",
    "../../svg/firebase.svg",
    "../../svg/git.svg",
  ];
  return (
    <section id="skills">
      <h1 className="skills-heading">
        <i className="fa-solid fa-laptop-code"></i>
        <span>Skills</span>
      </h1>
      <div className="skill-content">
        {images.map((image) => {
          return <SkillsCard img={image} />;
        })}
      </div>
    </section>
  );
};

export default Skills;
